import { CardHeader } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { FieldConfiguration } from '../../../api/ConfigApi';

const cardHeaderStyles = makeStyles(() => ({
	root: {
		padding: '0',
		marginBottom: '5px',
		marginTop: '5px',
		width: '100%',
	},
	title: {
		fontSize: '1rem',
	},
}));

interface Props {
	field: FieldConfiguration;
}

const FieldHeading = ({ field }: Props) => {
	const { name, heading } = field;
	const classes = cardHeaderStyles();

	if (!heading) {
		return null;
	}

	return (
		<CardHeader
			key={`${name}-heading`}
			className='content-panel-data-header'
			title={heading}
			classes={{
				root: classes.root,
				title: classes.title,
			}}
		/>
	);
};

export default FieldHeading;
